<script setup>
import EntityHistoryView from "@/shared/ui/history/EntityHistoryView.vue";

defineProps({
  form: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <EntityHistoryView entity-type="template" :entity-id="form?.code" />
</template>
